import { ECOLABELS, getEcolabelByValue } from '../../../config/ecolabels';

// Product photos in the hero showcase.
export const HERO_PRODUCT_COUNT = 4;

// The ecolabels floating around the photos: one each of three different badge
// colours (teal, blue and amber) so the composition doesn't read as one colour.
export const HERO_ECOLABEL_KEYS = ['plasticfreeproducts', 'ukmade', 'fairtradecertified'];

const hasImage = listing => listing?.images?.length > 0;

/**
 * The products to show in the hero: the newest products that have a photo,
 * never two from the same vendor, so the hero shows a spread of brands rather
 * than several shots of one product range. Listings whose vendor isn't known
 * are skipped, as they can't be told apart.
 *
 * @param {Array<Object>} listings listings, newest first (duplicates are fine)
 * @param {number} [count]
 * @returns {Array<Object>}
 */
export const pickHeroProducts = (listings = [], count = HERO_PRODUCT_COUNT) => {
  const picked = [];
  const seenListings = new Set();
  const seenVendors = new Set();
  listings.forEach(listing => {
    const uuid = listing?.id?.uuid;
    const vendor = listing?.author?.id?.uuid;
    if (
      picked.length < count &&
      hasImage(listing) &&
      uuid &&
      vendor &&
      !seenListings.has(uuid) &&
      !seenVendors.has(vendor)
    ) {
      seenListings.add(uuid);
      seenVendors.add(vendor);
      picked.push(listing);
    }
  });
  return picked;
};

/**
 * The three floating hero ecolabels, then `extra` more (different ones) to
 * stand in for product photos when there aren't enough products.
 *
 * @param {number} [extra]
 * @returns {Array<{key: string, label: string, src: string}>}
 */
export const pickHeroEcolabels = (extra = 0) => {
  const floating = HERO_ECOLABEL_KEYS.map(key => getEcolabelByValue(key)).filter(Boolean);
  const others = ECOLABELS.filter(e => !HERO_ECOLABEL_KEYS.includes(e.key));
  return [...floating, ...others.slice(0, Math.max(0, extra))];
};
